import type { OrphanCrewMember } from '@/types/orphanCrewNumber';

/**
 * Libellé affichable d'un membre d'équipage orphelin : « Prénom Nom », sinon
 * email, sinon « — ». Partagé entre la page liste et le dialog de libération
 * (revue 2026-06-01, finding E — fin de la duplication). TICKET-CRM-07.
 */
export function memberLabel(member: OrphanCrewMember | null): string {
  if (!member) return '—';
  const name = [member.first_name, member.last_name].filter(Boolean).join(' ').trim();
  return name || member.email || '—';
}

/**
 * Mappe les codes d'erreur métier de la RPC release_orphan_crew_number
 * (portés par error.message côté Supabase) vers un message FR affichable.
 * TICKET-CRM-07.
 */
export function releaseOrphanErrorMessage(message: string): string {
  const map: Record<string, string> = {
    access_denied: 'Accès réservé aux administrateurs.',
    reason_required: 'Une raison est obligatoire.',
    crew_not_found: 'Équipage introuvable.',
    crew_has_no_bpi_payment_case: 'Aucun dossier de paiement BPI associé — libération impossible.',
    crew_has_paid_payment: 'Cet équipage a un paiement encaissé — numéro non libérable.',
    crew_number_already_null: 'Numéro déjà libéré (par une autre opération).',
  };
  return map[message] ?? message;
}
